<template>
  <div class="login-page">
    <div class="login-wrap">
      <div class="title">
        <img class="logo" src="../../assets/images/logo.png" alt="衣加加云平台" title="衣加加云平台">
      </div>
      <div class="tab" ref="loginTab">
        <div class="item" :class="{act: tab === 1}" @click="switchTab(1)">快捷登录</div>
        <div class="item" :class="{act: tab === 2}" @click="switchTab(2)">密码登录</div>
        <div class="tab-active-bar" :style="tabActiveBarStyle"></div>
      </div>

      <el-form :model="codeForm" :rules="rules" ref="codeForm" class="form-wrap" v-if="tab === 1">
        <el-form-item prop="phone">
          <el-input placeholder="请输入手机号码" v-model.trim="codeForm.phone" prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        
        <el-form-item prop="code">
          <el-col :span="16">
            <el-input placeholder="请输入验证码" v-model="codeForm.code" prefix-icon="el-icon-unlock"></el-input>
          </el-col>
          <el-col :span="8">
            <el-button :disabled="!getCodeFlag" style="width: 96%;margin-left: 4%;" @click="getCodeHandle">
              {{getCodeFlag ? '获取验证码' : codeSeconds + 's'}}
            </el-button>
          </el-col>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="toCodeLogin" class="login-btn" :class="{opa: codeLoading}"><i class="el-icon-loading" v-show="codeLoading"></i>登录/注册</el-button>
        </el-form-item>
      </el-form>

      <el-form :model="passwordForm" :rules="rules" ref="passwordForm" class="form-wrap"  v-if="tab === 2">
        <el-form-item prop="phone">
          <el-input placeholder="请输入手机号码" v-model.trim="passwordForm.phone" prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input placeholder="请输入密码" type="password" v-model="passwordForm.password" prefix-icon="el-icon-key"></el-input>
        </el-form-item>
        <div class="btn-forget-wrap">
          <el-button class="btn-forget" type="text" @click="toFindPassword">忘记密码</el-button>
        </div>
        <el-form-item>
          <el-button type="primary" @click="toPasswordLogin" class="login-btn" :class="{opa: passwordLoading}"><i class="el-icon-loading" v-show="passwordLoading"></i>登录</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="login-footer">
      <y-footer />
    </div>
    
  </div>
</template>

<script>
import yFooter from '../../components/yFooter.vue'
import {validateMobile} from '@/utils/validate.js'
import request from '@/utils/request.js'
import api from '@/api/index.js'
export default {
  components: {
    yFooter
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'))
      } else if (!validateMobile(value)){
        callback(new Error('手机号码格式不正确'))
      } else {
        callback()
      }
    }
    return {
      tab: 1,  // 1 - 验证码登录   2 - 密码登录
      tabActiveBarStyle: {
        width: '0',
        transform: 'translateX(0px)'
      },
      getCodeFlag: true, // 获取验证码按钮标志
      codeTimer: null,   // 验证码定时器
      codeSeconds: 60,   // 剩余秒数

      codeLoading: false, // 提交loading
      passwordLoading: false, // 提交loading

      codeForm: {
        phone: '',
        code: ''
      },

      passwordForm: {
        phone: '',
        password: ''
      },

      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ]
      }
    }
  },
  mounted() {
    this.switchTab(1)
  },
  methods: {
    switchTab(tab) {
      let tabNode = this.$refs.loginTab
      let w = tabNode.querySelector('.act').offsetWidth
      this.tab = tab
      if (tab === 1) {
        this.tabActiveBarStyle = {
          width: w + 'px',
          transform: 'translateX(0px)'
        }
      }
      if (tab === 2) {
        this.tabActiveBarStyle = {
          width: w + 'px',
          transform: 'translateX('+ (w + 30) +'px)'
        }
      }
    },
    // 获取验证码
    getCodeHandle() {
      if (!this.getCodeFlag) return;
      this.$refs['codeForm'].validateField('phone', (err) => {
        if (!err) {
          this.getCodeFlag = false
          request({
            url: api.requestPhoneCode,
            noAuth: true,
            data: {
              phone: this.codeForm.phone
            }
          }).then(res => {
            if (res.errorCode === 200) {
              this.$message.success('验证码发送成功')
              this.codeSeconds = 60
              this.codeTimer = setInterval(() => {
                if (this.codeSeconds > 0) {
                  this.codeSeconds --
                } else {
                  clearInterval(this.codeTimer)
                  this.getCodeFlag = true
                }
              }, 1000)
            } else {
              this.$message.error('验证码发送失败')
              this.getCodeFlag = true
            }
          }).catch(err => {
              this.getCodeFlag = true
          })
        }
      })
    },
    // 通过验证码登录
    toCodeLogin() {
      if (this.codeLoading) return;
      this.$refs['codeForm'].validate(valid => {
        if (valid) {
          this.codeLoading = true
          let device = window.navigator.userAgent
          request({
            url: api.phoneNumberLoginOrRegiste,
            method: 'post',
            noAuth: true,
            data: {
              "phone": this.codeForm.phone,
							"code": this.codeForm.code,
              "userDeviceInfo": device
            }
          }).then(res => {
            // console.log('api.phoneNumberLoginOrRegiste:res', res)
            if (res.errorCode == 200) {
              this.$store.dispatch('setLoginInfo', {
                userId: res.data.userId,
                token: res.data.userLoginToken,
                userType: res.data.userType,
                phone: this.codeForm.phone,
              }).then(() => {
                this.$store.dispatch('getUserInfo')
                if (res.data.userType == 0) {
                  this.$router.push('/register')
                } else {
                  this.$router.push('/')
                  this.$notify({
                    title: '登录成功',
                    message: '恭喜你登录成功',
                    type: 'success',
                    duration: '2500'
                  })
                }
              })
              
            } else {
              this.$message.error(res.errorMsg || '登录失败') 
            }
          }).catch(err => {
            console.log('api.phoneNumberLoginOrRegiste:err', err)
          }).finally(() => {
            this.codeLoading = false
          })
        }
      })
    },
    // 通过密码登录
    toPasswordLogin() {
      if (this.passwordLoading) return;
      this.$refs['passwordForm'].validate(valid => {
        if (valid) {
          this.passwordLoading = true
          let device = window.navigator.userAgent
          request({
            url: api.requestAccountPasswdLogin,
            method: 'post',
            noAuth: true,
            data: {
              "phone": this.passwordForm.phone,
              "passWd": this.passwordForm.password,
              "userDeviceInfo": device
            }
          }).then(res => {
            // console.log('api.phoneNumberLoginOrRegiste:res', res)
            if (res.errorCode == 200) {
              this.$store.dispatch('setLoginInfo', {
                userId: res.data.userId,
                token: res.data.userLoginToken,
                userType: res.data.userType,
                phone: this.passwordForm.phone,
              }).then(() => {
                this.$store.dispatch('getUserInfo')
                this.$router.push('/')
                this.$notify({
                    title: '登录成功',
                    message: '恭喜你登录成功',
                    type: 'success',
                    duration: '2500'
                });
              })
              
            } else {
              this.$message.error(res.errorMsg || '登录失败') 
            }
          }).catch(err => {
            console.log('api.phoneNumberLoginOrRegiste:err', err)
          }).finally(() => {
            this.passwordLoading = false
          })
        }
      })      
    },
    // 去找回密码页面
    toFindPassword() {
      this.$router.push('/find-password')
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #f0f5fe url(../../assets/images/login_bg.jpg) no-repeat;
  background-position: center center;
  background-size: cover;
}
.login-wrap {
  width: 368px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -260px 0  0 -184px;
  .title {
    .logo {
      width: 294px;
      height: 44px;
      display: block;
      margin: 0 auto;
    }
  }
  .tab {
    margin-top: 40px;
    height: 44px;
    position: relative;
    .item {
      display: inline-block;
      margin-right: 30px;
      line-height: 44px;
      font-size: 18px;
      color: #555;
      cursor: pointer;
      &.act {
        color: #3F33FF
      }
    }
    .tab-active-bar {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 2px;
      background-color: #3f33ff;
      z-index: 1;
      transition: transform .3s cubic-bezier(.645,.045,.355,1);
      list-style: none;
    }
  }
  .form-wrap {
    margin-top: 40px;
    .btn-forget-wrap {
      text-align: right;
      .btn-forget {
        padding: 0;
      }
    }
    .login-btn {
      width: 100%;
      margin-top: 32px;
      &.opa {
        opacity: 0.5;
      }
    }
  }
}
.login-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>